import { makeStyles } from '@mui/styles';
import ApolloRichTextEditor from 'apollo-react/components/RichTextEditor';
import React from 'react';

const useStyles = makeStyles({
  container: {
    '& [class*=RichEditor-editor]': {
      fontSize: '14px !important',
    },
    '& [class*=public-DraftEditor-content]': {
      display: 'flex',
      alignItems: 'center',
      padding: '0 !important',
      minHeight: 'unset !important',
    },
  },
});

const ReadOnlyRichText = ({ ...rest }) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <ApolloRichTextEditor variant="view" {...rest} />
    </div>
  );
};

export default ReadOnlyRichText;
